import ApiService from "service/Api";

const RaffleMerchantService = {
  getAllRaffleMerchants: async (
    page: number,
    search: string,
    limit: number,
    filterCity: string
  ) => {
    const requestData = {
      method: "get",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      params: {
        search: search,
        page: page,
        per_page: limit,
        filter_city: filterCity,
      },
      url: "/admin/raffles/merchants",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },
};

export default RaffleMerchantService;
